import { useMemo } from "react";
import { Flex } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";

export default function Background({ icon }) {
  const LullabyIcon = useMemo(
    () =>
      ({ mb, mt }) => {
        return (
          <SvgContainer
            icon={icon}
            size="64px"
            fill="primaryLight"
            mb={mb}
            mt={mt}
          />
        );
      },
    [icon]
  );

  return (
    <Flex opacity={0.4}>
      <Flex mr="20px" flexDirection="column">
        <LullabyIcon mb="46px" />
        <LullabyIcon mb="46px" />
        <LullabyIcon />
      </Flex>
      <Flex mr="20px" flexDirection="column">
        <LullabyIcon mt="54px" mb="60px" />
        <LullabyIcon />
      </Flex>
      <Flex flexDirection="column">
        <LullabyIcon mb="46px" />
        <LullabyIcon mb="46px" />
        <LullabyIcon />
      </Flex>
    </Flex>
  );
}
